import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AdminShell } from "@/components/admin/AdminShell";
import { adminApi } from "@/lib/api";

export default function AdminLayout() {
  const [messageCount, setMessageCount] = useState(0);
  useEffect(() => {
    adminApi
      .messages({ status: "NOWA", limit: 1 })
      .then((d) => setMessageCount(d.statusCounts?.NOWA || 0))
      .catch(() => {});
  }, []);
  return (
    <AdminShell messageCount={messageCount}>
      <Outlet />
    </AdminShell>
  );
}
